<template>
  <div class="MainCategory margin">
    <div v-if="$root.globalData" class="MainCategory__title drRtl w margin">
      <div class="category__title">
        <h4>{{ $root.globalData.keys.industry_category_title }}</h4>
        <p>{{ $root.globalData.keys.industry_category_description }}</p>
      </div>

      <router-link to="/categories" class="seeAllCategory">{{
        $root.globalData.keys.industry_category_button
      }}</router-link>
    </div>

    <div v-if="homeData" class="CategoryBox drRtl w">
      <template v-for="(category, index) in homeData.all_industryCategories">
        <div v-if="showCategoryPermission(index)" :key="index" class="CategryBoxItem">
          <router-link :to="`/industry?categoryIds=${category.id}`">
            <img
              class="categoryImage"
              :src="category.image"
              alt="عکس دسته بندی کارخانه "
            />

            <span> {{ category.title }} </span>
          </router-link>
        </div>
      </template>
    </div>

    <Companys />
  </div>
</template>

<script>
import Companys from "./Companys.vue";
import FactoryImage from "../../assets/images/factoryImageLogo.jpg";
export default {
  data() {
    return {
      image: FactoryImage,
      categorytitle: " دسته بندی صنایع ",
      categorydesc: "لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم",
      SeenAllCategory: " مشاهده همه ",
    };
  },
  methods:{
    showCategoryPermission(index){
      if(window.innerWidth<768){
        return index<6
      }else{
        return index<10
      }
    }
  },
  computed: {
    homeData() {
      return this.$store.getters.getHomeData;
    },
  },
  components: { Companys },
};
</script>

<style scoped>
.MainCategory {
  box-shadow: -5px 0px 0px #fff;
}

.MainCategory__title {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 4rem 0;
  text-align: right;
}

.MainCategory__title h4 {
  font-size: 25px;
}

.MainCategory__title p {
  color: #666;
}

.seeAllCategory {
  background-color: #0d6efd;
  color: #fff;
  padding: 10px 30px;
  border-radius: 5px;
  border: 2px solid #0d6efd;
  transition: all ease 0.4s;
  cursor: pointer;
}
.CategryBoxItem {
  box-shadow: 0px 0px 5px #e3e3e3;
  border: 1px solid #eee;
  text-align: center;
}
.CategryBoxItem span {
  padding: 1rem 0;
  color: black;
  height: 80px;
  display: block;
}
.categoryImage {
  width: 100%;
  margin: 0 auto;
  padding: 10px;
  height: 160px;
  display: block;
}
@media (max-width: 768px) {
  .categoryImage {
    height: 80%;
  }
}
.seeAllCategory:hover {
  background-color: #fff;
  color: #0d6efd;
}

.CategoryBox {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  text-align: center;
  gap: 20px;
  overflow: hidden;
  margin: 0 auto;
}

@media only screen and (max-width: 600px) {
  .category__title h4 {
    font-size: 20px;
  }

  .category__title p {
    display: none;
  }
  .CategoryBox {
    grid-template-columns: 1fr 1fr;
  }
  .CategryBoxItem span {
    font-size: 11px;
  }
}
</style>
